const { getElements } = window.BAO.Utils

class PriceRange extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['min', 'max']
  }

  constructor () {
    super()

    this.type = 'shopify'

    if (window.theme.category || window.theme.searchResults) {
      this.type = 'klevu'
      this.state = {
        root: window.theme.category
          ? window.theme.category.stateLayer.state
          : window.theme.searchResults.stateLayer.state,
      }

      this.eventBus = window.theme.category
        ? window.theme.category.eventBus
        : window.theme.searchResults.eventBus
    }

    this.setMinAndMaxValues()
  }

  setupListeners () {
    super.setupListeners()

    getElements('input', { context: this }).forEach(el =>
      this.listeners.add(el, 'change', this.onRangeChange.bind(this)),
    )

    if (this.type === 'klevu') {
      this.eventBus.subscribe('state:resetPriceRange', () => {
        this.minInput.value = this.minInput.getAttribute('min')
        this.maxInput.removeAttribute('value')
      })
    }
  }

  /**
   * @param {InputEvent} e
   *
   * @returns {void}
   */
  onRangeChange (e) {
    this.adjustToValidValues(e.target, false)

    this.setMinAndMaxValues()

    if (this.maxInput.value === '') {
      this.maxInput.value = this.maxInput.getAttribute('max')
    }

    this.closest('form')?.dispatchEvent(
      new Event('input', {
        bubbles: true,
        cancelable: true,
      }),
    )

    if (this.type === 'klevu') {
      this.eventBus.publish('price-range:change', {
        min: this.minInput.value,
        max: this.maxInput.value,
      })
    }

    this.dispatchEvent(
      new CustomEvent('AFTER_PRICE_RANGE_CHANGE', {
        bubbles: true,
        detail: {
          min: this.minInput.value,
          max: this.maxInput.value,
        },
      }),
    )
  }

  setMinAndMaxValues () {
    if (this.maxInput.value) {
      this.minInput.setAttribute('max', this.maxInput.value)
    }
    if (this.minInput.value) {
      this.maxInput.setAttribute('min', this.minInput.value)
    }
    if (this.minInput.value === '') this.maxInput.setAttribute('min', '0')
    if (this.maxInput.value === '') {
      this.minInput.setAttribute('max', this.maxInput.getAttribute('max'))
    }
  }

  /**
   * @param {HTMLInputElement} input
   *
   * @returns {void}
   */
  adjustToValidValues (input, allowShortValues) {
    let value = Number(input.value)
    const min = Number(input.getAttribute('min'))
    const max = Number(input.getAttribute('max'))

    if (input.dataset?.priceRangeEl === 'max' && value === 0) {
      value = max
    }

    const hasShortValue =
      input.dataset?.priceRangeEl === 'min'
        ? input.value.length < String(min).length
        : input.value.length < String(max).length
    if (hasShortValue && allowShortValues) return

    if (value < min) input.value = min.toString()
    if (value > max) input.value = max.toString()
  }

  /**
   * @returns {HTMLInputElement}
   */
  get minInput () {
    return this.els.min.element
  }

  /**
   * @returns {HTMLInputElement}
   */
  get maxInput () {
    return this.els.max.element
  }
}

if (!customElements.get('price-range')) {
  customElements.define('price-range', PriceRange)
}
